<template>
  <article class="tablet:flex tablet:flex-row-reverse justify-between items-center container gap-x-12 spacer-section">
    <picture
            v-if="imgUri[0]"
            class="basis-1/2 w-full relative block aspect-[0.9] rounded-2xl overflow-hidden mb-4 tablet:mb-0"
    >
      <media-source
              :uri="imgUri[0]"
              :expose-only="false"
              :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
              sizes="100vw"
              :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
              format="webp"
              as="source"
      />
      <media-source
              :uri="imgUri[0]"
              :expose-only="false"
              :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
              sizes="100vw"
              format="jpg"
              as="img"
              class="w-full h-full object-cover relative z-1"
      />
    </picture>
    <header class="basis-1/2">
      <h1 class="hero-title text-brand mb-2 tablet:mb-8">
        <span class="block me-2">{{ page.title }}</span>
        <span v-if="page?.meta?.subtitle">{{ page.meta.subtitle }}</span>
      </h1>
      <ContentRenderer class="text-brand/66 leading-9 text-lg tablet:text-2xl mb-8 with-free-text font-sans" :value="page" />
      <div class="spacer-block text-brand">
        <p class="mb-4 inline-flex items-center">
          <CalendarDaysIcon class="size-4 tablet:size-6 me-2 opacity-88 text-brand-dark" />
          {{ config.opening_hours.human }}
        </p>
        <p>
          <a
                  :href="config.contact.address.url"
                  class="inline-flex items-center"
          >
            <MapPinIcon class="size-4 tablet:size-6 me-2  opacity-88 text-brand-dark" />
            {{ config.contact.address.human }}
          </a>
        </p>
      </div>
      <div class="flex flex-wrap gap-4 mb-8 tablet:mb-0">
        <ButtonCta v-for="cta in ctaList" :key="cta.label" :cta="cta" />
      </div>
    </header>
  </article>
</template>
<script setup lang="ts">
import type {PageCollectionItemBase} from "@nuxt/content";
import {CalendarDaysIcon, MapPinIcon} from "@heroicons/vue/24/outline";
const config = useRuntimeConfig().public;

const { page } = defineProps<{
    page: PageCollectionItemBase
}>();

const imgUri = computed<string[]>(() => (page.meta?.hero_images as string[] || []).map((img: string) => img.replace('/assets', '')));
const ctaList = computed(() => page.meta?.cta || []);

const img = useImage();
const url = useRequestURL();

const currentUrl = `${url.protocol}//${url.host}`;

useSeoMeta({
    title: page.meta!.seoTitle as string,
    ogTitle: page.meta!.seoTitle as string,
    description: page.meta!.seoDescription as string,
    ogDescription: page.meta!.seoDescription as string,
    ogImage: imgUri.value[0] ? currentUrl + img(imgUri.value[0] as string, {
        width: 1200,
        height: 630,
        fit: 'cover',
        format: 'jpg',
    }): '',
    twitterCard: 'summary_large_image',
});

const { organizationSchema, localBusinessSchema, websiteSchema, addSchemas } = useSchemaOrg();
addSchemas([organizationSchema, localBusinessSchema, websiteSchema]);
</script>